module.exports = __webpack_public_path__ + "static/media/Paleontologist.0799adad.jpg";